import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Offcanvas, Badge, Dropdown, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import LogoutPage from './Logout';
import ChangePassword from "../../Modals/ChangePassword";
import userpro from "../../../images/profile/profile.png";
import { Bell, CheckCheck, Clock, BellOff, MessageSquare } from "lucide-react";
import { NavMenuToggle } from "./NavHader";
import logo from "../../../../admin/images/logo.svg";
import { getPartnerNotifications, markNotificationAsRead } from "../../../services/UserServices/UserService";

const Header = ({ onNote }) => {
  const navigate = useNavigate();
  const [changePassword, setChangePassword] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [notifications, setNotifications] = useState([]);
  const [loadingNotifs, setLoadingNotifs] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [readCount, setReadCount] = useState(0);

  const fetchNotifications = useCallback(async () => {
    try {
      setLoadingNotifs(true);
      const isReadParam = activeTab === "unread" ? false : activeTab === "read" ? true : null;
      const res = await getPartnerNotifications(0, 50, isReadParam);
      const notifList = res?.data?.notifications || res?.data?.data?.notifications || res?.data?.data || (Array.isArray(res?.data) ? res.data : []);
      const list = Array.isArray(notifList) ? notifList : [];
      setNotifications(list);

      if (activeTab === "all") {
        const unreads = list.filter((n) => !n.isRead).length;
        const reads = list.filter((n) => n.isRead).length;
        setUnreadCount(unreads);
        setReadCount(reads);
      }
    } catch (err) {
      console.error("Error fetching partner notifications:", err);
    } finally {
      setLoadingNotifs(false);
    }
  }, [activeTab]);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);



  const handleNotificationClick = async (item) => {
    if (!item) return;

    if (!item.isRead) {
      try {
        await markNotificationAsRead(item._id);
        setNotifications((prev) =>
          prev.map((n) => (n._id === item._id ? { ...n, isRead: true } : n))
        );
        setUnreadCount((prev) => Math.max(0, prev - 1));
        setReadCount((prev) => prev + 1);
      } catch (err) {
        console.error("Error marking notification as read:", err);
      }
    }

    setShowNotifications(false);

    const partnerId = item.partner?._id || item.partner?.id || item.partnerId;
    if (partnerId) {
      navigate(`/partner-detail/${partnerId}`);
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      await markNotificationAsRead();
      setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
      setReadCount((prev) => prev + unreadCount);
      setUnreadCount(0);
      toast.success("All notifications marked as read");
    } catch (err) {
      console.error("Error marking all notifications as read:", err);
      toast.error("Failed to mark notifications as read");
    }
  };

  const filteredNotifications = notifications.filter((n) => {
    if (activeTab === "unread") return !n.isRead;
    if (activeTab === "read") return n.isRead;
    return true;
  });

  return (
    <div className="navv qx-header">
      <ChangePassword password={changePassword} onHide={() => setChangePassword(false)} />

      <div className="header-content qx-header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left qx-header-left d-flex align-items-center gap-3">
              <button
                type="button"
                className="qx-sidebar-toggle"
                onClick={NavMenuToggle}
                aria-label="Toggle Sidebar"
              >
                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
              <Link to="/dashboard" className="qx-header-logo-mobile d-lg-none">
                <img src={logo} alt="Logo" />
              </Link>
            </div>
            
            <ul className="navbar-nav header-right prof align-items-center gap-2">
            
              <li className="nav-item me-2 position-relative">
                <button
                  type="button"
                  className="qx-header-notif-btn"
                  onClick={() => setShowNotifications(true)}
                  title="Notifications"
                >
                  <Bell size={22} strokeWidth={2} color="#1a1208" />
                  {unreadCount > 0 && (
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-danger"
                      style={{
                        fontSize: "0.65rem",
                        width: "18px",
                        height: "18px",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px solid #ffffff",
                      }}
                    >
                      {unreadCount}
                    </span>
                  )}
                </button>
              </li>
     <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="i-false c-pointer nav-link"
                  to=""
                  role="button"
                  data-toggle="dropdown"
                >
                  <div className="header-info">
                    <span>
                      <strong>Admin</strong>
                    </span>
                  </div>
                  <img src={userpro} width={20} alt="" />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  align="end"
                  className="dropdown-menu dropdown-menu-end qx-header-profile-menu"
                  renderOnMount
                  popperConfig={{
                    strategy: "fixed",
                    modifiers: [
                      { name: "offset", options: { offset: [0, 14] } },
                      { name: "flip", enabled: false },
                      { name: "preventOverflow", enabled: false },
                    ],
                  }}
                >
                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
 
      <Offcanvas
        show={showNotifications}
        onHide={() => setShowNotifications(false)}
        placement="end"
        style={{ width: "410px", maxWidth: "92vw", backgroundColor: "#F8D179" }}
      >
        <Offcanvas.Header closeButton className="border-bottom pb-3" style={{ background: "linear-gradient(95deg, #F8D179 0%, #FFB30B 100%)" }}>
          <div className="d-flex align-items-center justify-content-between w-100 me-2">
            <Offcanvas.Title className="fw-bold d-flex align-items-center gap-2 mb-0" style={{ color: "#800001", fontSize: "1.15rem" }}>
              <Bell size={20} />
              Notifications
              {unreadCount > 0 && (
                <Badge bg="danger" pill className="ms-1" style={{ fontSize: "0.75rem" }}>
                  {unreadCount} new
                </Badge>
              )}
            </Offcanvas.Title>
            {unreadCount > 0 && (
              <button
                type="button"
                className="btn btn-link text-decoration-none p-0 border-0 small fw-semibold d-flex align-items-center gap-1"
                style={{ fontSize: "0.75rem", color: "#800001" }}
                onClick={handleMarkAllAsRead}
              >
                <CheckCheck size={14} />
                Mark all read
              </button>
            )}
          </div>
        </Offcanvas.Header>

        <Offcanvas.Body className="p-0 d-flex flex-column" style={{ backgroundColor: "#F8D179" }}>
          {/* Full Width Segmented Pill Tab Bar */}
          <div className="p-3 border-bottom" style={{ backgroundColor: "rgba(255, 255, 255, 0.25)" }}>
            <div
              className="d-flex align-items-center w-100 p-1"
              style={{
                backgroundColor: "#FFB30B",
                borderRadius: "9999px",
                boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.12)",
              }}
            >
              <button
                type="button"
                className="btn border-0 fw-bold text-center py-2 px-1"
                style={{
                  flex: "1 1 0%",
                  width: "33.333%",
                  borderRadius: "9999px",
                  fontSize: "0.82rem",
                  backgroundColor: activeTab === "all" ? "#A60000" : "transparent",
                  color: activeTab === "all" ? "#ffffff" : "#1a1208",
                  boxShadow: activeTab === "all" ? "0 2px 4px rgba(0,0,0,0.15)" : "none",
                  transition: "all 0.2s ease",
                }}
                onClick={() => setActiveTab("all")}
              >
                All ({notifications.length})
              </button>
              <button
                type="button"
                className="btn border-0 fw-bold text-center py-2 px-1"
                style={{
                  flex: "1 1 0%",
                  width: "33.333%",
                  borderRadius: "9999px",
                  fontSize: "0.82rem",
                  backgroundColor: activeTab === "unread" ? "#A60000" : "transparent",
                  color: activeTab === "unread" ? "#ffffff" : "#1a1208",
                  boxShadow: activeTab === "unread" ? "0 2px 4px rgba(0,0,0,0.15)" : "none",
                  transition: "all 0.2s ease",
                }}
                onClick={() => setActiveTab("unread")}
              >
                Unread ({unreadCount})
              </button>
              <button
                type="button"
                className="btn border-0 fw-bold text-center py-2 px-1"
                style={{
                  flex: "1 1 0%",
                  width: "33.333%",
                  borderRadius: "9999px",
                  fontSize: "0.82rem",
                  backgroundColor: activeTab === "read" ? "#A60000" : "transparent",
                  color: activeTab === "read" ? "#ffffff" : "#1a1208",
                  boxShadow: activeTab === "read" ? "0 2px 4px rgba(0,0,0,0.15)" : "none",
                  transition: "all 0.2s ease",
                }}
                onClick={() => setActiveTab("read")}
              >
                Read ({readCount})
              </button>
            </div>
          </div>

          {/* Notification List */}
          <div className="flex-grow-1 overflow-auto p-3" style={{ maxHeight: "calc(100vh - 140px)" }}>
            {loadingNotifs ? (
              <div className="text-center py-5">
                <Spinner animation="border" style={{ color: "#800001" }} />
              </div>
            ) : filteredNotifications.length > 0 ? (
              <div className="d-flex flex-column gap-2">
                {filteredNotifications.map((item) => {
                  const partnerHost = item.partner?.hostName || item.partner?.partnerData?.companyName || "Partner";
                  const partnerCompany = item.partner?.partnerData?.companyName;
                  const phone = item.partner?.phoneNumber ? `${item.partner?.countryCode || "+91"} ${item.partner?.phoneNumber}` : "";
                  const formattedTime = item.createdAt
                    ? new Date(item.createdAt).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "";

                  return (
                    <div
                      key={item._id}
                      className={`card border-0 shadow-sm rounded-3 p-3 position-relative ${
                        !item.isRead ? "bg-white" : "bg-white opacity-85"
                      }`}
                      style={{
                        borderLeft: !item.isRead ? "4px solid #800001" : "4px solid #cbd5e1",
                        transition: "all 0.2s ease",
                        cursor: "pointer",
                      }}
                      onClick={() => handleNotificationClick(item)}
                    >
                      <div className="d-flex align-items-start gap-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                          style={{
                            width: "38px",
                            height: "38px",
                            backgroundColor: !item.isRead ? "rgba(128,0,0,0.1)" : "#f1f5f9",
                            color: "#800001",
                          }}
                        >
                          <MessageSquare size={18} />
                        </div>

                        <div className="flex-grow-1 min-w-0 me-1">
                          <div className="d-flex align-items-center justify-content-between mb-1">
                            <h6
                              className={`mb-0 ${!item.isRead ? "fw-bold text-dark" : "fw-semibold text-secondary"}`}
                              style={{ fontSize: "0.85rem" }}
                            >
                              WhatsApp Limit Alert (&gt;80%)
                            </h6>
                            {!item.isRead && (
                              <span
                                className="badge rounded-circle bg-danger p-1"
                                style={{ width: "8px", height: "8px" }}
                                title="Unread"
                              ></span>
                            )}
                          </div>
                          <p className="text-dark small mb-1 fw-bold lh-sm" style={{ fontSize: "0.8rem" }}>
                            {partnerHost} {partnerCompany ? `(${partnerCompany})` : ""}
                          </p>
                          <p className="text-muted small mb-2 lh-sm" style={{ fontSize: "0.78rem" }}>
                            Partner has consumed more than 80% of WhatsApp message limit. Click to view profile.
                          </p>
                          <div className="d-flex align-items-center justify-content-between pt-1 border-top border-light">
                            <span className="text-muted small d-flex align-items-center gap-1" style={{ fontSize: "0.72rem" }}>
                              <Clock size={12} />
                              {formattedTime}
                            </span>
                            {phone && (
                              <span className="badge bg-light text-secondary border fw-medium" style={{ fontSize: "0.7rem" }}>
                                {phone}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center my-auto text-muted">
                <BellOff size={36} className="mb-2 text-secondary opacity-50" />
                <h6 className="fw-bold mb-1 text-dark">No Notifications</h6>
                <p className="small mb-0 text-muted">
                  {activeTab === "unread"
                    ? "You have no unread notifications."
                    : activeTab === "read"
                    ? "No read notifications found."
                    : "Your notification box is empty."}
                </p>
              </div>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Header;